import React, { useState } from 'react';
import {
  Typography,
  ButtonPro,
  InputPro,
  TextAreaProControlled
} from 'components';
import './EditDesignationModal.scss'; // Reuse the same styles
import { useAppDispatch } from 'store';
import { createDesignation } from 'store/MasterData';

interface AddDesignationModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const AddDesignationModal: React.FC<AddDesignationModalProps> = ({
  isOpen,
  onClose
}) => {
  const dispatch = useAppDispatch();
  const [formData, setFormData] = useState({
    name: '',
    description: ''
  });

  const [errors, setErrors] = useState<{ [key: string]: string }>({});

  const handleInputChange = (field: string, value: string) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value
    }));

    // Clear error when user starts typing
    if (errors[field]) {
      setErrors((prev) => ({
        ...prev,
        [field]: ''
      }));
    }
  };

  const validateForm = (): boolean => {
    const newErrors: { [key: string]: string } = {};

    if (!formData.name.trim()) {
      newErrors.name = 'Designation name is required';
    }

    if (formData.description && formData.description.trim().length < 10) {
      newErrors.description = 'Description must be at least 10 characters';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = () => {
    if (validateForm()) {
      dispatch(
        createDesignation({
          name: formData.name,
          description: formData.description || undefined
        })
      );
      handleClose();
    }
  };

  const handleClose = () => {
    setFormData({
      name: '',
      description: ''
    });
    setErrors({});
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="edit-designation-modal">
        <div className="modal-header">
          <Typography
            text="Add New Designation"
            type="heading3"
            weight="bold"
            className="modal-title"
          />
          <ButtonPro
            label="×"
            type="icon"
            size="small"
            onClick={handleClose}
            buttonClassNames="close-button"
          />
        </div>

        <div className="modal-content">
          <div className="form-group">
            <InputPro
              label="Designation Name"
              name="designationName"
              id="designationName"
              placeholder="Enter designation name"
              value={formData.name}
              onChange={(value) => handleInputChange('name', value)}
              inputClass={errors.name ? 'error' : ''}
              required
            />
            {errors.name && (
              <span className="error-message">{errors.name}</span>
            )}
          </div>

          <div className="form-group">
            <TextAreaProControlled
              label="Description"
              name="designationDescription"
              id="designationDescription"
              placeholder="Enter designation description (optional)"
              value={formData.description}
              onChange={(value) => handleInputChange('description', value)}
              inputClass={errors.description ? 'error' : ''}
            />
            {errors.description && (
              <span className="error-message">{errors.description}</span>
            )}
          </div>
        </div>

        <div className="modal-footer">
          <ButtonPro
            label="Cancel"
            type="white"
            size="base"
            onClick={handleClose}
          />
          <ButtonPro
            label="Create Designation"
            type="primary"
            size="base"
            onClick={handleSave}
            buttonClassNames="create-designation-button"
          />
        </div>
      </div>
    </div>
  );
};
